<div class="card mt-4">
  <h4 class="card-header">Available properties - {{operation}}</h4>
  <div class="card-body">
    <div class="form-group has-search mb-3">
      <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
      <input type="text" name="search" [(ngModel)]="searchText" class="form-control" placeholder="Search by property name" autocomplete="off" spellcheck="false">
    </div>
    @for (property of filteredProperties; track $index) {
      <div (click)="loadPage(property.id!,action)" class="comm-div">
        <p  class="comm-p">
          @if (property.property_type == 'house') {
            <fa-icon class="l-icon" [icon]="faHouse"></fa-icon>
          }
          @if (property.property_type == 'strata') {
            <fa-icon class="l-icon" [icon]="faBuilding"></fa-icon>
          }
          {{property.name}}
          <fa-icon class="float-right" [icon]="faCircleArrowRight"></fa-icon></p>
        </div>
      }
    </div>
  </div>

